export default __webpack_public_path__ + "static/media/feature-targeting.e21e8185.png";